import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconFacilitiesIQ = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Layer_1",
	xmlns: "http://www.w3.org/2000/svg",
	x: "0px",
	y: "0px",
	viewBox: "0 0 604 604",
	style: { enableBackground: "new 0 0 604 604" },
	xmlSpace: "preserve",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("style", {
			type: "text/css",
			children: "\n	.st0{fill:#005C71;}\n	.st1{fill:#FDBA12;}\n	.st2{fill:#00ADBD;}\n	.st3{fill:#FFB800;}\n	.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#FDBA12;}\n	.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\n"
		}),
		/* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("path", {
			style: { fill: "" },
			className: "st0",
			d: "M30,90c0-38.7,31.3-70,70-70h404c38.7,0,70,31.3,70,70v404c0,38.7-31.3,70-70,70H100c-38.7,0-70-31.3-70-70V90 z"
		}) }),
		/* @__PURE__ */ _jsx("path", {
			className: "st1",
			d: "M157,222h10v85h-10V222z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M137,292h50v141h-50V292z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st3",
			d: "M202.4,204.5l6.1-7.9l148,114.2l-6.1,7.9L202.4,204.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st4",
			d: "M202.4,204.5l148,114.2l6.1-7.9l-148-114.2L202.4,204.5z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st2",
			d: "M331.9,330l30.5-39.6l140.9,108.8l-30.5,39.6L331.9,330z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M365,383c44.7,0,81-36.3,81-81s-36.3-81-81-81s-81,36.3-81,81S320.3,383,365,383z M365,433 c72.3,0,131-58.7,131-131s-58.7-131-131-131s-131,58.7-131,131S292.7,433,365,433z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "st5",
			d: "M225,181.5c0,34.5-28,62.5-62.5,62.5S100,216,100,181.5s28-62.5,62.5-62.5S225,147,225,181.5z M162.5,204 c12.4,0,22.5-10.1,22.5-22.5S174.9,159,162.5,159S140,169.1,140,181.5S150.1,204,162.5,204z"
		})
	]
});
const ForwardRef = forwardRef(SvgIconFacilitiesIQ);
export default ForwardRef;
